import {AbstractSearchCore, IFacet, IResult} from ".";

export abstract class AbstractSubscriber {
  groupId: string = "";
  constructor (groupId: string) {
    this.groupId = groupId;
  };
  getGroupId(): string {
    return this.groupId;
  }
  abstract attached(searchCore: AbstractSearchCore): Promise<void>;  
  abstract detaching(): void;
  abstract onSearchTextUpdate(text: string): Promise<void>;
  abstract onFacetUpdate(facets: IFacet[]): Promise<void>;
  abstract onResultUpdate(result: IResult): Promise<void>;
}
